export default __webpack_public_path__ + "static/media/creativity_fr.2fe15b19.png";